import React from 'react'
import { Option, Override, useDesignLanguagePerClass } from '@afterpaytouch/core'

import { Route } from '../../config/router'
import { TrackOnMount, useMonitoringWithEnduringEventProperties } from '../../integrations/monitoring'
import { TrackingEvent } from '../../model/monitoring'
import { useAppRouter, useIsHidePaymentDay, useSelectedPreferredDay } from '../../state'
import { useTranslation } from '../../utils/convergence'

import styles from './style.module.css'

export const PaymentDay = (): JSX.Element | null => {
  const { t } = useTranslation()
  const selectedPreferredDay = useSelectedPreferredDay()
  const designLanguageStyles = useDesignLanguagePerClass(styles)
  const { logEvent } = useMonitoringWithEnduringEventProperties()
  const router = useAppRouter()
  const hidePaymentDay = useIsHidePaymentDay()

  const handleOnClick = (): void => {
    logEvent(TrackingEvent.PRESSED_SUMMARY_PAGE_ALIGN_PAYMENTS_TAB)
    router.push(Route.PREFERRED_PAYMENT_DAY)
  }

  if (hidePaymentDay) {
    return null
  }

  const dayTextByWeekday: Record<number, string> = {
    0: t('preferredDay.weekday.0'),
    1: t('preferredDay.weekday.1'),
    2: t('preferredDay.weekday.2'),
    3: t('preferredDay.weekday.3'),
    4: t('preferredDay.weekday.4'),
    5: t('preferredDay.weekday.5'),
    6: t('preferredDay.weekday.6'),
  }

  return (
    <div className={designLanguageStyles.container}>
      <Option
        text={dayTextByWeekday[selectedPreferredDay] ?? ''}
        floatingHeader={t('preferredDay.title')}
        onClick={handleOnClick}
        override={Override.DisabledBorderRadius}
        testNameSpace={'preferred-payment-day'}
      />
      <TrackOnMount eventName={TrackingEvent.VIEWED_ALIGN_PAYMENT_MESSAGE} />
    </div>
  )
}
